import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.controller = new AbortController();

        this.el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let target = e.target;
            if (target.tagName !== 'A') {
                target = target.parentNode;
            }
            window.history.pushState({}, '', target.href);
            this.loadContent(target.href, true);
        }, true);
    }

    loadContent(url, append = false) {
        this.controller.abort();
        this.controller = new AbortController();

        fetch(url, {
            signal: this.controller.signal
        })
        .then(response => response.text())
        .then(data => {
            let parser = new DOMParser();

            let html = parser.parseFromString(data, 'text/html');
            let results = html.querySelector('.js-results');

            if (results.querySelectorAll('div').length === 0) {
                document.querySelector('.js-no-results').style.display = null;
                document.querySelector('.js-results').style.display = 'none';
                document.querySelector('.js-next-page').style.display = 'none';
            } else {
                document.querySelector('.js-no-results').style.display = 'none';
                document.querySelector('.js-results').style.display = null;
                if (append) {
                    document.querySelector('.js-results').insertAdjacentHTML('beforeend', results.innerHTML);
                } else {
                    document.querySelector('.js-results').innerHTML = results.innerHTML;
                }

                let nextPage = html.querySelector('.js-next-page');
                if (nextPage && nextPage.href.length && nextPage.href !== window.location.href) {
                    document.querySelector('.js-next-page').href = nextPage.href;
                    document.querySelector('.js-next-page').style.display = null;
                } else {
                    document.querySelector('.js-next-page').style.display = 'none';
                }
            }
        })
        .catch(error => {
            if (error.name === 'AbortError') {
                console.log('Fetch aborted');
            } else {
                console.error('Error:', error);
            }
        });
    }

    destroy() {

    }
}